import { getIndustryGroupTypes, getIndustryTypes } from '@/bundles/Companies/types/companyIndustryType';

export const getCompanyInitialStoreState = () => ({
  companiesFullList: [],
  industryTypes: getIndustryGroupTypes(),
  industryGroupTypes: getIndustryTypes()
});
